// Ensure correct imports
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import apiClientService from './service/api-client.service';
import { BrowserRouter } from "react-router-dom";

async function app() {
    // render(<Loading/>)

    await apiClientService.configureClient();

    ReactDOM.render(
        // <Suspense fallback={<Loading />}>
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>,
        document.getElementById('root')
    );
}

app();

reportWebVitals(console.log);